class GCProductReviews extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.gc-product-reviews__toggle');
    if (!this.button || this.abortController) return;
    this.abortController = new AbortController();
    this.enhanceReplies = () => {
      for (const reply of this.querySelectorAll('.jdgm-rev > .jdgm-rev__reply')) {
        const details = document.createElement('details');
        details.className = 'gc-review-reply';
        const summary = document.createElement('summary');
        summary.textContent = this.dataset.replyLabel;
        details.append(summary);
        reply.before(details);
        details.append(reply);
      }
    };
    this.enhanceReplies();
    this.replyObserver = new MutationObserver(() => this.enhanceReplies());
    this.replyObserver.observe(this, { childList: true, subtree: true });
    this.setAttribute('data-enhanced', '');
    this.button.hidden = false;
    this.button.addEventListener('click', () => {
      const expanded = this.toggleAttribute('data-expanded');
      this.button.setAttribute('aria-expanded', String(expanded));
      this.button.textContent = expanded ? this.button.dataset.collapse : this.button.dataset.expand;
      if (!expanded) {
        this.setAttribute('tabindex', '-1');
        this.focus({ preventScroll: true });
        requestAnimationFrame(() => requestAnimationFrame(() => this.scrollIntoView({ block: 'start', behavior: 'auto' })));
      }
    }, { signal: this.abortController.signal });
  }
  disconnectedCallback() {
    this.replyObserver?.disconnect();
    this.abortController?.abort();
    this.abortController = null;
  }
}
if (!customElements.get('gc-product-reviews')) customElements.define('gc-product-reviews', GCProductReviews);
